<template>
    <div class="page-view">
    	<header-bar @showSearch= "open"></header-bar>
        <transition name="slide-left"> 
        <router-view> </router-view>
        </transition>
        <transition name="t-slide">  
        <search v-show="searchShow" @closeSearch="close"></search>
        </transition>
    </div>
</template>

<script>
import headerBar from '../components/Head.vue'
import {httpHead,apiUrl} from '../common/util/config.js'
import search from '../components/search.vue'
export default{
    data () {
        return {
            searchShow: false,
            transitionname: 'slide-left'
        }
    },
    methods: {
        open () {
            this.searchShow = true;
        },
        close () {
            this.searchShow = false;
        }
    },
    components: {
    	headerBar,
        search
    }
}
</script>
<style lang="scss">
    .t-slide-enter-active,.t-slide-leave-active{
        -webkit-transition: all .25s linear;
        transition: all .25s linear;
    }
    .t-slide-enter,.t-slide-leave-active{
        transform:translateY(50px);
        opacity:0;
    }
    .slide-left-leave{
        position:absolute;
    }
    .slide-left-leave-active{
        position:absolute;
        opacity:0;
        z-index:-1;
    }
    .slide-left-enter{
        transform:translateY(30px);
        opacity:0;
    }
    .slide-left-enter-active{
        -webkit-transition: all .5s linear;
        transition: all .5s linear;
    }
</style>


// WEBPACK FOOTER //
// src/page/pagesView.vue